module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAaElEQVQ4jd2SUQrAIAxDn8P732gIw3NNf1RYndrKvhYolNI0aRU+QgCSMU4AVwakTWHnZUFJbIJygMbNQ+RQKg7x5kC7xtBBoFx4kk8deOBe5B3q22rR+n+wgnRg/tL1BtFKBK4NTo8MiJQqBLFIjYIAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/screens/Tube/images/icon/tube-calculate.png
 ** module id = 2721
 ** module chunks = 71
 **/